import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isChecked'
})

export class IsCheckedPipe implements PipeTransform {
    public transform(value: string, selectedOptions: string[], selected: string[], useSelected: boolean): boolean {
        if(useSelected){
            return selected && selected.length && selected.indexOf(value) > -1;
        }
        return selectedOptions && selectedOptions.length > 0 && selectedOptions.indexOf(value) > -1;
    }
}
